import {ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import {
  CtBinaryOperator,
  CtControlConfiguration,
  CtControlService,
  CtControlTypes,
  CtDatatableActionConfiguration,
  CtDatatableActionCustomConfiguration,
  CtDatatableConfiguration,
  CTDatatablePaginationParameter,
  CtModelConfiguration,
  CtSelectControlValue,
  CtThemeTypes,
  MaterialControlOptions,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtModelOperator,
  CtModelRouteData,
  CtModelService,
  CtModelType
} from "@ctsolution/ct-framework";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi";
import {ActivatedRoute, Router} from "@angular/router";
import {UserRouteData} from "../../../_core/route-data/user.route-data";
import {UserInfoFormTemplateRouteData} from "../../../_core/route-data/user-info-form-template.route-data";
import {FormTemplateRouteData} from "../../../_core/route-data/form-template.route-data";
import {DEFAULT_DATATABLE_CONFIGURATION} from "../../../_core/constants";
import {CtFieldCustomColumn} from "@ctsolution/ct-framework/lib/ct-datatable/_core/ct-field-custom.column";
import {Role} from "../../../_core/enum/role";
import {UserFeeManagerConfiguration} from "../user-fee-manager/user-fee-manager.configuration";
import {CtManagerService} from "../../../_core/lib/ct-manager.service";
import { ChangePasswordParameter, CtAuthenticationService, CtProfileService } from '@ctsolution/ct-authentication';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UserChangePasswordDialogComponent, UserChangePasswordResult } from './user-change-password-dialog/user-change-password-dialog.component';
import { JwtService } from '../../../_core/lib/jwt.service';
import { FileService } from '../../../_core/lib/file.service';
import { FileGet } from '../../../_core/classes/file-get';

@Component({
  selector: 'app-user-edit',
  template: `
    <ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>

    <ng-container *ngIf="enableFeeManager">
      <div class="ct-manager-master-detail-container">
        <app-user-fee-manager [configuration]="userFeeManagerConfiguration"></app-user-fee-manager>
      </div>
    </ng-container>

    <ng-container *ngIf="enableMasterDetail && this.viewModel.MONITORING">

      <app-user-info-work-data></app-user-info-work-data>

    </ng-container>

    <!-- Moduli (CTFormTemplate) collegati allo user - solo se la feature "Modules" è abilitata in SiteConfiguration -->
    <ng-container *ngIf="enableMasterDetail && viewModel.MODULES && modulesConfiguration">
      <div class="modules-datatable-cntr">
        <div class="title-model-cntr">
          <h3>Moduli:</h3>
          <h4>Moduli collegati a questo utente.</h4>
        </div>
        <ct-model [configuration]="modulesConfiguration"></ct-model>
      </div>
    </ng-container>

    <!-- Cella "Data visione": se valorizzata mostra la data, altrimenti un pallino rosso (non visionato). -->
    <ng-template #modulesViewedCell let-row="row">
      <ng-container *ngIf="row?.ReadCompletedDate; else notViewedDot">
        {{ row.ReadCompletedDate | date: 'dd/MM/yyyy' }}
      </ng-container>
      <ng-template #notViewedDot>
        <span class="status-dot not-viewed" title="Non visionato"></span>
      </ng-template>
    </ng-template>

    <!-- Azione di riga: download del documento del modulo.
         Disponibile solo per i moduli scaricabili: ReadOnly = false e FormModuleDataOid valorizzato (≠ -1). -->
    <ng-template #moduleDownloadButton let-value="value">
      <button
        *ngIf="isModuleDownloadable(value)"
        mat-icon-button
        color="primary"
        title="Scarica documento"
        (click)="downloadModuleFile(value)">
        <mat-icon>download</mat-icon>
      </button>
    </ng-template>

    <!-- Sezione cambio password - visibile solo se sono nel dettaglio del mio utente -->
    <ng-container *ngIf="enableMasterDetail && isUserHimself">
        <app-change-password-card
    *ngIf="!isLoading"
    title="Account"
    description="Modifica la tua password"
    buttonLabel="Modifica Password">
  </app-change-password-card>
    </ng-container>

    <!-- Popup: lista di TUTTI i documenti (FormTemplate/List, niente Lookup), non filtrati per utente -->
    <ng-template #addModuleDialog>
      <h2 mat-dialog-title>Aggiungi documento</h2>
      <mat-dialog-content>
        <ng-container *ngIf="addModuleDatatable">
          <div class="modules-toolbar">
            <button mat-raised-button class="filter-toggle" *ngIf="addModuleDatatable.filtersEnabled" (click)="addModuleTableRef.toggleFilters()">
              <mat-icon [color]="addModuleTableRef.viewModel.filtersVisible ? 'primary' : 'accent'">
                {{ addModuleTableRef.viewModel.filtersVisible ? 'filter_alt_off' : 'filter_alt' }}
              </mat-icon>
            </button>
          </div>
          <ct-datatable #addModuleTableRef [configuration]="addModuleDatatable" [currentPage]="addModuleCurrentPage" (reload)="onAddModuleReload($event)" (filter)="onAddModuleFilter($event)"></ct-datatable>
        </ng-container>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Chiudi</button>
      </mat-dialog-actions>
    </ng-template>
  `,
  styles: [`
    /* Card container per la sezione cambio password */
    :host ::ng-deep .change-password-card {
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      padding: 24px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      transition: box-shadow 0.3s ease;
      margin: 20px 15px !important;
    }

    .change-password-card:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    /* Header della card con icona e testi */
    .card-header {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;
    }

    .header-icon {
      color: #006595; /* Colore primario dal tuo progetto */
      font-size: 32px;
      width: 32px;
      height: 32px;
    }

    .header-content {
      flex: 1;
    }

    .card-title {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 1.4;
    }

    .card-description {
      margin: 4px 0 0 0;
      font-size: 14px;
      color: #666666;
      line-height: 1.5;
    }

    /* Sezione azioni con il pulsante */
    .card-actions {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .card-actions button {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 24px;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
    }

    .card-actions button mat-icon {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }

    /* Titolo sezione moduli: stesso stile di "Dati Contrattuali" (scoped nell'altro componente) */
    .title-model-cntr {
      display: flex;
      flex-direction: column;
      padding-left: 20px;
    }
    .title-model-cntr h4 {
      margin-top: 0;
    }

    /* Toolbar tabella moduli (bottone Aggiungi) */
    .modules-toolbar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      margin-bottom: 8px;
    }

    /* Pallino stato "Visionato" */
    .status-dot {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #bdbdbd;
    }
    .status-dot.viewed { background: #4caf50; }
    .status-dot.not-viewed { background: #f44336; }

    /* Nessuna freccia di ordinamento in testata */
    ::ng-deep .modules-datatable-cntr .sort-btn {
      display: none !important;
    }

    /* Tabella moduli: celle a sinistra e centrate in verticale */
    ::ng-deep .modules-datatable-cntr .datatable-body-cell {
      display: flex !important;
      align-items: center !important;
    }
    ::ng-deep .modules-datatable-cntr .datatable-body-cell .datatable-body-cell-label,
    ::ng-deep .modules-datatable-cntr .datatable-header-cell .datatable-header-cell-label {
      display: flex;
      align-items: center;
      justify-content: flex-start !important;
      text-align: left !important;
    }
  `]
})
export class UserEditComponent {

  configuration: CtModelConfiguration<UserEditComponent> | null = null;
  userFeeManagerConfiguration: UserFeeManagerConfiguration = UserFeeManagerConfiguration
    .create();

  /** Tabella dei moduli collegati allo user, model-driven (ct-model su UserInfo_FormTemplate). */
  modulesConfiguration: CtModelConfiguration<any> | null = null;

  /** Numero di documenti per pagina (usato dal popup "Aggiungi"). */
  private readonly MODULES_PAGE_SIZE = 10;

  /** Oid dello user in dettaglio (per l'associazione dei nuovi moduli). */
  private modulesUserOid: number | null = null;

  /** Template della cella "Visionato": pallino verde/rosso. */
  @ViewChild('modulesViewedCell') modulesViewedCellTpl: TemplateRef<any> | null = null;
  @ViewChild('moduleDownloadButton') moduleDownloadButtonTpl: TemplateRef<any> | null = null;

  /** Tabella (nel popup) dei documenti FormTemplate collegabili allo user. */
  addModuleDatatable: CtDatatableConfiguration | null = null;

  /** Tutti i documenti caricati nel popup (paginazione/filtro locali). */
  private addModuleAllRows: any[] = [];

  /** Filtri per colonna attivi nel popup. */
  private addModuleFilters: { [key: string]: any } | null = null;

  /** Pagina corrente della tabella del popup. */
  addModuleCurrentPage = 1;

  @ViewChild('addModuleDialog') addModuleDialogTpl: TemplateRef<any> | null = null;

  private addModuleDialogRef: any = null;

  isUserHimself: boolean = false;

  viewModel = {
    CRM: false,
    MONITORING : false,
    MODULES: false
  }

  get enableMasterDetail(): boolean {
    return !!this.configuration?.RouteData?.id;
  }

  get userHasAgentRole() {
    return this.configuration?.form?.value?.Role?.toLowerCase() === Role.AGENT.toLowerCase();
  }

  get enableFeeManager() {
    return this.userHasAgentRole && this.enableMasterDetail && this.viewModel.CRM;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private managerService: CtManagerService,
    private cdr : ChangeDetectorRef,
    private jwtService : JwtService,
    private modelService : CtModelService <any>,
    private controlService: CtControlService,
    private dialog: MatLegacyDialog,
    private fileService: FileService,
    private snackBar: MatSnackBar
  ) {
  }

  ngAfterViewInit() {

    this.setup();

    this.route
    .data
    .subscribe(data => {
      data['title'] = 'CT_PAGE.BREADCRUMBS.DetailUser';
      this.cdr.detectChanges();
    })

  }

  async setup() {

    const routeData: CtModelRouteData = UserRouteData()
      .setModelType(CtModelType.FORM);

    const pId: string | null = this.route.snapshot.paramMap.get("id");

    if (pId) {

      routeData
        .setId(+pId);

      this.userFeeManagerConfiguration
        .setUserOid(routeData.id)

      this.isUserHimself = await this.checkUser(pId);

    }

    this.viewModel.CRM = await this.managerService.hasEnabled.CRM() ?? false;
    this.viewModel.MONITORING = await this.managerService.hasEnabled.monitoring() ?? false;
    this.viewModel.MODULES = await this.managerService.hasEnabled.modules() ?? false;

    // Tabella dei moduli: la carico solo se la feature "Modules" è abilitata in SiteConfiguration.
    if (pId && this.viewModel.MODULES) {
      this.loadUserModules(+pId);
    }
    const userHasMonitoringManagementEnabled = await this.managerService.hasEnabled.monitoring() ?? false;

    const fieldsCustomTemplates: CtFieldCustomColumn[] = [
      {prop: "DailyWorkingHours", visible: userHasMonitoringManagementEnabled},
      {prop: "WeeklyWorkingHours", visible: userHasMonitoringManagementEnabled},
      {prop: "WorkJob", visible: userHasMonitoringManagementEnabled},
    ];

    this.configuration = CtModelConfiguration
      .create<UserEditComponent>()
      .setRouteData(routeData)
      .setFieldsCustomTemplates(fieldsCustomTemplates)

  }

  /**
   * Carica i moduli collegati allo user in dettaglio: POST UserInfo_FormTemplate/List
   * filtrata per UserInfo.Oid = oid dell'utente (NON OwnedOnlyList, che è dell'utente loggato).
   * Colonne: Titolo, Visionato (pallino), Data visione; azione di riga: elimina.
   */
  private loadUserModules(userOid: number): void {

    this.modulesUserOid = userOid;

    // Datatable con azione di riga custom: download del documento (solo moduli scaricabili).
    const datatableConfiguration = DEFAULT_DATATABLE_CONFIGURATION();
    if (this.moduleDownloadButtonTpl) {
      datatableConfiguration.setCustomDatatableActionConfiguration(
        CtDatatableActionCustomConfiguration
          .create()
          .setTemplateOutlet(this.moduleDownloadButtonTpl));
    }

    // Tabella model-driven (ct-model) su UserInfo_FormTemplate, come le altre liste del progetto:
    // List server-side, filtro in-header, paginazione e ordinamento nativi.
    const config = CtModelConfiguration
      .create()
      .setRouteData(UserInfoFormTemplateRouteData())
      .setCTDatatableConfiguration(datatableConfiguration)
      // Solo eliminazione associazione + "Aggiungi" (Create → popup documenti).
      .setOperations([CtModelOperator.Create, CtModelOperator.Delete])
      .setOnCreate(() => this.openAddModuleDialog(userOid));

    // Mostra solo i moduli di QUESTO utente (filtro costante server-side).
    config
      .filterValues
      .addConstantFilter(
        CTModelDatatableFilter
          .create()
          .setField('UserInfo.Oid')
          .setValue(userOid)
          .setOperatorType(CtBinaryOperator.Equal));

    // Colonna "Data visione": mostra la data se valorizzata, altrimenti un pallino rosso.
    if (this.modulesViewedCellTpl) {
      config.setFieldsCustomTemplates([
        { prop: 'ReadCompletedDate', cellTemplate: this.modulesViewedCellTpl }
      ]);
    }

    this.modulesConfiguration = config;

  }

  /**
   * Un modulo è scaricabile solo se ReadOnly = false e FormModuleDataOid è valorizzato (≠ -1).
   */
  isModuleDownloadable(row: any): boolean {
    return row?.ReadOnly === false && row?.FormModuleDataOid > 0;
  }

  /**
   * Download del documento del modulo (riga UserInfo_FormTemplate).
   * L'url è composto dalla proprietà FormModuleDataOid del DTO:
   * GET /FormModuleData/GetDocument/{FormModuleDataOid} (il base REST include già /api).
   */
  downloadModuleFile(row: any): void {

    if (!this.isModuleDownloadable(row)) return;

    const formModuleDataOid = row.FormModuleDataOid;
    const fileName = `${row?.FormTemplate?.Name ?? row?.FormTemplate?.Title ?? 'modulo'}.pdf`;

    const file: FileGet = {
      Endpoint: `/FormModuleData/GetDocument/${formModuleDataOid}`,
      FileName: fileName
    };

    this.fileService.downloadAttachmentByEndPoint(file, fileName);

  }

  /**
   * Costruisce il controllo di filtro (testo) per una colonna, in tema Material outline,
   * come fanno le tabelle native del framework.
   */
  private buildFilterControl(name: string, label: string): CtControlConfiguration {
    const control = this.controlService.getDefaultConfiguration({ name, label, type: CtControlTypes.TEXT });
    control.setTheme(CtThemeTypes.MATERIAL).setValidators(null).setNullValueEnabled(true);
    if (!control.materialOptions) control.setMaterialOptions(MaterialControlOptions.create());
    control.materialOptions?.setAppearance('outline');
    return control;
  }

  /**
   * Apre il popup con TUTTI i documenti (FormTemplate/List, senza Lookup), non filtrati per utente.
   * Selezionando una riga il documento viene collegato allo user (Create su UserInfo_FormTemplate).
   */
  private openAddModuleDialog(userOid: number): void {

    if (!this.addModuleDialogTpl) return;

    // Carico i documenti collegabili (FormTemplate/List) via getList, con i filtri costanti:
    // - GetOnlyNotConnectedToUser (OperatorType 54, valore = oid utente): solo i non ancora collegati;
    // - Type = 6.
    // I dati restano in memoria: paginazione e filtro in-header sono gestiti localmente,
    // come nelle altre tabelle moduli (evita anche il 500 su FormTemplate/Lookup).
    const configuration = CtModelConfiguration
      .create()
      .setRouteData(FormTemplateRouteData());

    const operators = CtModelDatatableOperators
      .create()
      .setPagination(new CTDatatablePaginationParameter().setElementsForPage(null))
      .setFilters([
        CTModelDatatableFilter.create().setField('GetOnlyNotConnectedToUser').setValue(userOid).setOperatorType(54 as CtBinaryOperator),
        CTModelDatatableFilter.create().setField('Type').setValue(6).setOperatorType(CtBinaryOperator.Equal)
      ]);

    this.addModuleDatatable = null;
    this.addModuleAllRows = [];
    this.addModuleFilters = null;
    this.addModuleCurrentPage = 1;

    this.modelService
      .getList(configuration, operators)
      .subscribe({
        next: (response: CtWebapiGenericResponse<any>) => {

          const list = (response?.Result?.DataSource ?? []) as any[];

          const rows = list.map(template => ({
            oid: template?.Oid,
            name: template?.Name
              ?? template?.Title
              ?? template?.Description
              ?? template?.Code
              ?? `Documento #${template?.Oid}`
          }));

          this.addModuleAllRows = rows;

          this.addModuleDatatable = CtDatatableConfiguration
            .create()
            .setController('add-module-documents')
            .setScrollbarH(true)
            .setFiltersEnabled(true)
            .setExternalPaging(true)
            .setExternalSorting(false)
            .setLoadingIndicator(false)
            .setLimit(this.MODULES_PAGE_SIZE)
            .setCount(rows.length)
            .setColumns([
              { prop: 'name', name: 'Documento', sortable: false, control: this.buildFilterControl('name', 'Documento'), ColumnBuilder: { FilterEnabled: true } }
            ] as any)
            .setRows(this.getAddModulePage(1))
            // Azione di riga: "+" → collega il documento allo user.
            .setCustomDatatableActionConfiguration(
              CtDatatableActionCustomConfiguration
                .create()
                .setActionButtonConfig(
                  CtDatatableActionConfiguration
                    .create()
                    .setIcon('add')
                    .setColor('primary'))
                .setCallback((row: any) => this.associateModule(userOid, row)));

        },
        error: (err: any) => {
          console.error('Errore durante il caricamento dei documenti:', err);
          this.addModuleDatatable = null;
        }
      });

    this.addModuleDialogRef = this.dialog.open(this.addModuleDialogTpl, {
      width: '900px',
      maxWidth: '95vw',
      autoFocus: false,
      panelClass: 'add-module-dialog'
    });

  }

  /** Righe del popup filtrate in base ai filtri per colonna attivi. */
  private getFilteredAddModuleRows(): any[] {
    if (!this.addModuleFilters) return this.addModuleAllRows;
    return this.addModuleAllRows.filter(row => Object.keys(this.addModuleFilters!).every(key => {
      const term = (this.addModuleFilters?.[key] ?? '').toString().trim().toLowerCase();
      if (!term) return true;
      return (row?.[key] ?? '').toString().toLowerCase().includes(term);
    }));
  }

  /** Fetta di documenti (1-based) della pagina richiesta, sulle righe filtrate. */
  private getAddModulePage(page: number, elementsForPage: number = this.MODULES_PAGE_SIZE): any[] {
    const start = Math.max(0, (page - 1)) * elementsForPage;
    return this.getFilteredAddModuleRows().slice(start, start + elementsForPage);
  }

  /** Evento (filter) del datatable del popup: applica il filtro e torna a pagina 1. */
  onAddModuleFilter(values: { [key: string]: any } | null): void {
    this.addModuleFilters = values;
    if (!this.addModuleDatatable) return;
    this.addModuleCurrentPage = 1;
    this.addModuleDatatable.setCount(this.getFilteredAddModuleRows().length);
    this.addModuleDatatable.setRows(this.getAddModulePage(1));
  }

  /** Evento (reload) del datatable del popup: fornisce la fetta della pagina richiesta. */
  onAddModuleReload(pagination?: CTDatatablePaginationParameter): void {
    if (!this.addModuleDatatable) return;
    const page = pagination?.Page ?? 1;
    const elementsForPage = pagination?.ElementsForPage ?? this.MODULES_PAGE_SIZE;
    this.addModuleCurrentPage = page;
    this.addModuleDatatable.setRows(this.getAddModulePage(page, elementsForPage));
    this.addModuleDatatable.setLoadingIndicator(false);
  }

  /**
   * Crea l'associazione UserInfo_FormTemplate tra lo user e il documento selezionato
   * (Create standard sul controller, senza passare dal Lookup).
   * I duplicati sono già esclusi dal filtro BE "GetOnlyNotConnectedToLoggedUser".
   */
  private associateModule(userOid: number, template: any): void {

    const templateOid = template?.oid ?? template?.Oid;
    if (!templateOid) return;

    const body = {
      UserInfo: { Oid: userOid },
      FormTemplate: { Oid: templateOid }
    };

    const configuration = CtModelConfiguration
      .create()
      .setRouteData(UserInfoFormTemplateRouteData());

    this.modelService
      .putInfos(configuration, body)
      ?.subscribe({
        next: () => {
          this.addModuleDialogRef?.close();
          window.location.reload();
        },
        error: (err: any) => console.error('Errore durante il collegamento del documento allo user:', err)
      });

  }

  async checkUser(oid : string) {
    const a = await this.jwtService.getUserInfoOid();
    if (a === oid) return true;
    return false;
  }

}
